"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontWeights = exports.GlobalFontWeights = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _styledComponents = require("styled-components");
var _templateObject, _templateObject2;
var fontWeights = (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  .bf-light {\n    font-weight: 300;\n  }\n\n  .bf-medium {\n    font-weight: 500;\n  }\n\n  .bf-semibold {\n    font-weight: 600;\n  }\n\n  .bf-bold {\n    font-weight: 700;\n  }\n\n  .bf-boldest {\n    font-weight: 800;\n  }\n\n  .bf-italic {\n    font-style: italic;\n  }\n"])));
exports.fontWeights = fontWeights;
var GlobalFontWeights = (0, _styledComponents.createGlobalStyle)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)([" \n  body {\n    ", "\n  }\n"])), fontWeights);
exports.GlobalFontWeights = GlobalFontWeights;